'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/menu-button.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var buttonStyles = function buttonStyles(_ref) {
  var theme = _ref.theme,
    open = _ref.open;
  return {
    height: '6.4rem',
    border: 'none',
    borderBottom: '5px solid ' + (open ? theme.colorBlack : theme.colorPrimary),
    backgroundColor: theme.colorBlack,
    color: theme.colorWhite,
    fontFamily: theme.font,
    fontWeight: 400,
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: theme.space_sm,
    padding: '0px 18px',
    fontSize: '18px',
    cursor: 'pointer'
  };
};
var Button = _glamorous2.default.button(buttonStyles);
var barWidth = 20;
var barHeight = 2;
var barSpacing = 4;
var hamburgerStyles = function hamburgerStyles(_ref2) {
  var theme = _ref2.theme,
    open = _ref2.open;
  return {
    width: barWidth,
    height: barSpacing * 2 + barHeight * 3,
    position: 'relative',
    marginRight: '1rem',
    '& span': {
      position: 'absolute',
      height: barHeight,
      width: barWidth,
      background: theme.colorWhite,
      opacity: 1,
      left: 0,
      transform: 'rotate(0deg)',
      transition: '0.15s ease-in-out',
      transformOrigin: 'left center',
      '&:nth-child(1)': Object.assign({
        top: 0
      }, open ? {
        transform: 'rotate(45deg)',
        left: '3px',
        top: -barHeight / 2
      } : {}),
      '&:nth-child(2)': Object.assign({
        top: barHeight + barSpacing
      }, open ? {
        width: '0%',
        opacity: 0
      } : {}),
      '&:nth-child(3)': Object.assign({
        top: barHeight * 2 + barSpacing * 2
      }, open ? {
        transform: 'rotate(-45deg)',
        left: '3px',
        top: barHeight * 2 + barSpacing * 2 + barHeight / 2
      } : {})
    }
  };
};
var Hamburger = _glamorous2.default.span(hamburgerStyles);
MobileMenuButton.propTypes = {
  open: _propTypes.bool
};
function MobileMenuButton(_ref3) {
  var open = _ref3.open,
    rest = _objectWithoutProperties(_ref3, ['open']);
  return _react2.default.createElement(Button, Object.assign({
    open: open
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85
    },
    __self: this
  }), _react2.default.createElement(Hamburger, {
    open: open,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 86
    },
    __self: this
  }, _react2.default.createElement('span', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87
    },
    __self: this
  }), _react2.default.createElement('span', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88
    },
    __self: this
  }), _react2.default.createElement('span', {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89
    },
    __self: this
  })), 'Menu');
}
exports.default = MobileMenuButton;